module.exports = new __parcel__URL__("revenue_performance.82890e81.svg").toString();